import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { SettingsNavSection } from 'src/config/settingsNav';

interface StorefrontSideNavProps {
  sections: SettingsNavSection[];
}

const StorefrontSideNav = React.memo(({ sections }: StorefrontSideNavProps) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  return (
    <nav id={'storefront-side-nav'} className={'storefront-side-nav'} aria-label={t('storefrontNav.title')}>
      {sections.map((section) => {
        const labelId = `settings-side-nav__section-label--${section.key}`;
        return (
          <div className={'settings-side-nav__section'} key={section.key}>
            {/* Every section shows its heading, including single-item ones. Hiding the
                heading when a section had one item left that item orphaned at the top
                level — "Transaction Categories" read as a peer of Organization rather
                than as the child of Accounting that it is. */}
            <p className={'settings-side-nav__section-label'} id={labelId}>
              {t(section.labelKey)}
            </p>
            <ul aria-labelledby={labelId}>
              {section.items.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className={classNames('settings-side-nav__link', {
                      'settings-side-nav__link--current': pathname === item.path,
                    })}
                    aria-current={pathname === item.path ? 'page' : undefined}
                  >
                    {t(item.labelKey)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        );
      })}
    </nav>
  );
});

export default StorefrontSideNav;
